<template>
  <transition name="fade">
    <div class="hero" v-if="!loading">
      <div class="container text-wrapper">
        <h2>{{ pageTitle | unMachine }}</h2>
        <p>{{ pageIntroText }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "hero",
  computed: {
    ...mapGetters({
      pageTitle: "getPageTitle",
      pageIntroText: "getPageIntroText",
      loading: "getLoading",
    }),
  },
};
</script>

<style scoped>
.hero {
  background: url("~@/assets/img/hero.jpg") no-repeat center / cover;
  color: var(--eggshell);
  margin-bottom: 2rem;
}

.text-wrapper {
  align-items: flex-start;
  display: flex;
  padding-bottom: 8rem;
  padding-top: 2.5rem;
  position: relative;
  z-index: 1;
}

img {
  height: auto;
  height: 270px;
  object-fit: cover;
  width: 100%;
  position: absolute;
  top: 0;
}

h2 {
  font-family: BebasNeue;
  font-size: 3rem;
  font-weight: 400;
  line-height: 1;
  margin: 0;
  text-transform: uppercase;
}

p {
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.11;
  margin: 0 0 0 2rem;
}

@media all and (max-width: 500px) {
  .text-wrapper {
    display: block;
  }

  p {
    margin: 0;
  }
}
</style>
